/**
 * Formats a timestamp into a relative "time ago" string (e.g., "5s", "2m", "1h").
 */
export function formatTimeAgo(ms: number): string {
  const sec = Math.floor((Date.now() - ms) / 1000);
  if (sec < 0) return "now";
  if (sec < 60) return sec + "s ago";
  const min = Math.floor(sec / 60);
  if (min < 60) return min + "m ago";
  const hours = Math.floor(min / 60);
  if (hours < 24) return hours + "h ago";
  return Math.floor(hours / 24) + "d ago";
}

/**
 * Formats a duration in seconds into a human-readable string (e.g., "45s", "3m 12s").
 */
export function formatDuration(seconds: number): string {
  if (seconds < 60) return seconds + "s";
  const min = Math.floor(seconds / 60);
  const remSec = seconds % 60;
  if (min < 60) return `${min}m ${remSec}s`;
  const hours = Math.floor(min / 60);
  const remMin = min % 60;
  return `${hours}h ${remMin}m`;
}
